/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MediaBaseService } from '../media-base-service';
import { MediaApiConfiguration } from '../media-api-configuration';
import { MediaStrictHttpResponse } from '../media-strict-http-response';

import { KeyValueModel } from '../models/key-value-model';
import { userGet$Json } from '../fn/user/user-get-json';
import { UserGet$Json$Params } from '../fn/user/user-get-json';
import { userGet$Plain } from '../fn/user/user-get-plain';
import { UserGet$Plain$Params } from '../fn/user/user-get-plain';
import { userIdGet$Json } from '../fn/user/user-id-get-json';
import { UserIdGet$Json$Params } from '../fn/user/user-id-get-json';
import { userIdGet$Plain } from '../fn/user/user-id-get-plain';
import { UserIdGet$Plain$Params } from '../fn/user/user-id-get-plain';
import { UserModel } from '../models/user-model';
import { UserModelSearchResultModel } from '../models/user-model-search-result-model';
import { userPost$Json } from '../fn/user/user-post-json';
import { UserPost$Json$Params } from '../fn/user/user-post-json';
import { userPost$Plain } from '../fn/user/user-post-plain';
import { UserPost$Plain$Params } from '../fn/user/user-post-plain';
import { userSearchUserPost$Json } from '../fn/user/user-search-user-post-json';
import { UserSearchUserPost$Json$Params } from '../fn/user/user-search-user-post-json';
import { userSearchUserPost$Plain } from '../fn/user/user-search-user-post-plain';
import { UserSearchUserPost$Plain$Params } from '../fn/user/user-search-user-post-plain';
import { userUserRoleTypesGet$Json } from '../fn/user/user-user-role-types-get-json';
import { UserUserRoleTypesGet$Json$Params } from '../fn/user/user-user-role-types-get-json';
import { userUserRoleTypesGet$Plain } from '../fn/user/user-user-role-types-get-plain';
import { UserUserRoleTypesGet$Plain$Params } from '../fn/user/user-user-role-types-get-plain';
import { userUserStatusTypesGet$Json } from '../fn/user/user-user-status-types-get-json';
import { UserUserStatusTypesGet$Json$Params } from '../fn/user/user-user-status-types-get-json';
import { userUserStatusTypesGet$Plain } from '../fn/user/user-user-status-types-get-plain';
import { UserUserStatusTypesGet$Plain$Params } from '../fn/user/user-user-status-types-get-plain';

@Injectable({ providedIn: 'root' })
export class MediaUserService extends MediaBaseService {
  constructor(config: MediaApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userSearchUserPost()` */
  static readonly UserSearchUserPostPath = '/User/SearchUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSearchUserPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userSearchUserPost$Plain$Response(params?: UserSearchUserPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<UserModelSearchResultModel>> {
    return userSearchUserPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSearchUserPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userSearchUserPost$Plain(params?: UserSearchUserPost$Plain$Params, context?: HttpContext): Observable<UserModelSearchResultModel> {
    return this.userSearchUserPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<UserModelSearchResultModel>): UserModelSearchResultModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSearchUserPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userSearchUserPost$Json$Response(params?: UserSearchUserPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<UserModelSearchResultModel>> {
    return userSearchUserPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSearchUserPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userSearchUserPost$Json(params?: UserSearchUserPost$Json$Params, context?: HttpContext): Observable<UserModelSearchResultModel> {
    return this.userSearchUserPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<UserModelSearchResultModel>): UserModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `userIdGet()` */
  static readonly UserIdGetPath = '/User/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  userIdGet$Plain$Response(params: UserIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<UserModel>> {
    return userIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userIdGet$Plain(params: UserIdGet$Plain$Params, context?: HttpContext): Observable<UserModel> {
    return this.userIdGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<UserModel>): UserModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  userIdGet$Json$Response(params: UserIdGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<UserModel>> {
    return userIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userIdGet$Json(params: UserIdGet$Json$Params, context?: HttpContext): Observable<UserModel> {
    return this.userIdGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<UserModel>): UserModel => r.body)
    );
  }

  /** Path part for operation `userGet()` */
  static readonly UserGetPath = '/User';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGet$Plain$Response(params?: UserGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<UserModel>> {
    return userGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGet$Plain(params?: UserGet$Plain$Params, context?: HttpContext): Observable<UserModel> {
    return this.userGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<UserModel>): UserModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGet$Json$Response(params?: UserGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<UserModel>> {
    return userGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGet$Json(params?: UserGet$Json$Params, context?: HttpContext): Observable<UserModel> {
    return this.userGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<UserModel>): UserModel => r.body)
    );
  }

  /** Path part for operation `userPost()` */
  static readonly UserPostPath = '/User';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userPost$Plain$Response(params?: UserPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return userPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userPost$Plain(params?: UserPost$Plain$Params, context?: HttpContext): Observable<string> {
    return this.userPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userPost$Json$Response(params?: UserPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return userPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userPost$Json(params?: UserPost$Json$Params, context?: HttpContext): Observable<string> {
    return this.userPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `userUserRoleTypesGet()` */
  static readonly UserUserRoleTypesGetPath = '/User/UserRoleTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userUserRoleTypesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  userUserRoleTypesGet$Plain$Response(params?: UserUserRoleTypesGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
    return userUserRoleTypesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userUserRoleTypesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userUserRoleTypesGet$Plain(params?: UserUserRoleTypesGet$Plain$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.userUserRoleTypesGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userUserRoleTypesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  userUserRoleTypesGet$Json$Response(params?: UserUserRoleTypesGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
    return userUserRoleTypesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userUserRoleTypesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userUserRoleTypesGet$Json(params?: UserUserRoleTypesGet$Json$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.userUserRoleTypesGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `userUserStatusTypesGet()` */
  static readonly UserUserStatusTypesGetPath = '/User/UserStatusTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userUserStatusTypesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  userUserStatusTypesGet$Plain$Response(params?: UserUserStatusTypesGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
    return userUserStatusTypesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userUserStatusTypesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userUserStatusTypesGet$Plain(params?: UserUserStatusTypesGet$Plain$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.userUserStatusTypesGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userUserStatusTypesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  userUserStatusTypesGet$Json$Response(params?: UserUserStatusTypesGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
    return userUserStatusTypesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userUserStatusTypesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userUserStatusTypesGet$Json(params?: UserUserStatusTypesGet$Json$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.userUserStatusTypesGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

}
